import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box
} from '@mui/material';

const AddDomainDialog = ({ open, onClose, onAdd }) => {
  const [domain, setDomain] = useState('');
  const [customer, setCustomer] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    if (!domain.trim()) {
      setError('Domain is required');
      return;
    }
    if (!customer.trim()) {
      setError('Customer name is required');
      return;
    }
    onAdd({ domain: domain.trim(), customer: customer.trim() });
    handleClose();
  };

  const handleClose = () => {
    setDomain('');
    setCustomer('');
    setError('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New Domain</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <TextField
            autoFocus
            label="Domain"
            fullWidth
            value={domain}
            onChange={(e) => setDomain(e.target.value)}
            placeholder="example.com"
            error={!!error && !domain.trim()}
            helperText={!domain.trim() && error}
            sx={{ mb: 2 }}
          />
          <TextField
            label="Customer Name"
            fullWidth
            value={customer}
            onChange={(e) => setCustomer(e.target.value)}
            placeholder="Customer name"
            error={!!error && !customer.trim()}
            helperText={!customer.trim() && error}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Add Domain
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddDomainDialog; 